// utils/Seo.jsx
import { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { useQuery } from "@apollo/client";
import { LangContext } from "./LanguageProvider";
import { GET_SEO_DATA } from "../queries";
import getAbsoluteUrl from "./getAbosulteUrl";
import setImageAbsoluteUrl from "./setImageAbosulteUrl";
import { getFromLocalStorage, saveToLocalStorage } from "./localStorage";

const SEO = ({ page }) => {
  const [seoInfo, setSeoInfo] = useState(() => {
    const cached = getFromLocalStorage(page);
    return cached?.pages?.[page]?.seo || null;
  });

  useQuery(GET_SEO_DATA, {
    variables: { uri: `/${page}/` },
    skip: !!seoInfo,
    onCompleted: (data) => {
      const postData = data.pageBy;
      const toStore = {
        [page]: {
          seo: postData,
        },
      };
      saveToLocalStorage(page, toStore);
      setSeoInfo(postData);
    },
  });

  if (!seoInfo) return null;

  return (
    <Helmet>
      <title>{seoInfo?.title}</title>
      <meta name="description" content={seoInfo?.seo?.description} />
      <meta name="robots" content={seoInfo?.seo?.robots?.join(", ")} />
      <link rel="canonical" href={getAbsoluteUrl(seoInfo?.seo?.canonicalUrl)} />
      <meta property="og:title" content={seoInfo?.seo?.openGraph?.title} />
      <meta property="og:description" content={seoInfo?.seo?.openGraph?.description} />
      <meta property="og:image" content={setImageAbsoluteUrl(seoInfo?.seo?.openGraph?.image?.url)} />
      <meta property="og:url" content={getAbsoluteUrl(seoInfo?.seo?.openGraph?.url)} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SEO;
